/* Proposed only: preserves all preview text; not installed on the live theme. */
(function () {
  'use strict';
  function partition(units, maxWords = 240, maxVerse = 6) {
    const pages = []; let page = [], words = 0, verses = 0;
    for (const unit of units) {
      const n = unit.text.trim().split(/\s+/u).filter(Boolean).length;
      if (page.length && (words > 40 || verses > 0) &&
          (words + n > maxWords || (unit.verse && verses >= maxVerse))) {
        pages.push(page); page = []; words = 0; verses = 0;
      }
      page.push(unit); words += n; if (unit.verse) verses++;
    }
    if (page.length) pages.push(page);
    return pages;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { partition };
  if (typeof document === 'undefined') return;
  function plain(node) {
    if (node.nodeType === 3) return node.nodeValue;
    if (node.nodeType !== 1) return '';
    if (node.tagName === 'BR') return '\n';
    const content = Array.from(node.childNodes, plain).join('');
    return /^(P|DIV|SECTION|BLOCKQUOTE|H[1-6]|LI)$/.test(node.tagName) ? '\n' + content + '\n' : content;
  }
  function unitsFrom(root) {
    const clone = root.cloneNode(true), blocks = [];
    if (Array.from(clone.children).some(e => /^(P|SECTION|BLOCKQUOTE|H[1-6])$/.test(e.tagName))) {
      let pending = document.createElement('div');
      for (const child of Array.from(clone.childNodes)) {
        if (child.nodeType === 1 && /^(P|SECTION|BLOCKQUOTE|H[1-6])$/.test(child.tagName)) {
          if (plain(pending).trim()) { blocks.push(pending); pending = document.createElement('div'); }
          blocks.push(child);
        } else pending.append(child);
      }
      if (plain(pending).trim()) blocks.push(pending);
    } else {
      let block = document.createElement('div'), breaks = 0;
      for (const child of Array.from(clone.childNodes)) {
        block.append(child);
        if (child.nodeType === 1 && child.tagName === 'BR') breaks++;
        else if (child.nodeType !== 3 || child.nodeValue.trim()) breaks = 0;
        if (breaks >= 2) {
          if (plain(block).trim()) blocks.push(block);
          block = document.createElement('div'); breaks = 0;
        }
      }
      if (plain(block).trim()) blocks.push(block);
    }
    return blocks.map(node => {
      const text = plain(node), lines = text.trim().split('\n').filter(s => s.trim());
      return { node, text, verse: lines.length === 5 && /^[IVXLCDM]+[.)]?$/u.test(lines[0].trim()) };
    });
  }
  function enhance(root) {
    if (root.dataset.nilePaginated || root.querySelector('audio,video,iframe,form')) return;
    const originalNodes = Array.from(root.childNodes);
    const original = plain(root).replace(/\s+/gu, ''), units = unitsFrom(root);
    if (units.map(u => u.text).join('').replace(/\s+/gu, '') !== original) return;
    const groups = partition(units); if (groups.length < 2) return;
    const rtl = getComputedStyle(root).direction === 'rtl';
    const nav = document.createElement('nav'); nav.className = 'nile-preview-pages';
    nav.dir = rtl ? 'rtl' : 'ltr'; nav.setAttribute('aria-label', 'Preview pages | صفحات المعاينة');
    const prev = document.createElement('button'); prev.type = 'button'; prev.textContent = rtl ? 'السابق | Previous' : 'Previous | السابق';
    const numbers = document.createElement('span'); numbers.className = 'nile-preview-pages__numbers'; numbers.dir = 'ltr';
    const next = document.createElement('button'); next.type = 'button'; next.textContent = rtl ? 'التالي | Next' : 'Next | التالي';
    const status = document.createElement('span'); status.className = 'nile-preview-pages__status'; status.dir = 'auto'; status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite');
    const fragment = document.createDocumentFragment(); const panels = [], buttons = [];
    groups.forEach((group, i) => {
      const panel = document.createElement('div'); panel.className = 'nile-preview-page'; panel.hidden = i !== 0;
      group.forEach(unit => panel.append(unit.node)); fragment.append(panel); panels.push(panel);
      const b = document.createElement('button'); b.type = 'button'; b.textContent = String(i + 1); b.setAttribute('aria-label', `Page ${i + 1} | الصفحة ${i + 1}`);
      b.addEventListener('click', () => show(i)); numbers.append(b); buttons.push(b);
    });
    let active = 0;
    function show(index) {
      active = Math.max(0, Math.min(panels.length - 1, index));
      panels.forEach((panel, i) => { panel.hidden = i !== active; });
      buttons.forEach((b, i) => { if (i === active) b.setAttribute('aria-current', 'page'); else b.removeAttribute('aria-current'); });
      prev.disabled = active === 0; next.disabled = active === panels.length - 1;
      status.textContent = `Page ${active + 1} of ${panels.length} | الصفحة ${active + 1} من ${panels.length}`;
    }
    prev.addEventListener('click', () => show(active - 1)); next.addEventListener('click', () => show(active + 1));
    nav.addEventListener('keydown', event => {
      let target;
      if (event.key === 'Home') target = 0;
      if (event.key === 'End') target = panels.length - 1;
      if (event.key === 'ArrowRight') target = active + (rtl ? -1 : 1);
      if (event.key === 'ArrowLeft') target = active + (rtl ? 1 : -1);
      if (target !== undefined) { event.preventDefault(); show(target); buttons[active].focus(); }
    });
    nav.append(prev, numbers, next, status);
    try {
      root.replaceChildren(fragment); root.before(nav); root.dataset.nilePaginated = 'true'; show(0);
    } catch (error) {
      root.replaceChildren(...originalNodes); nav.remove(); delete root.dataset.nilePaginated; throw error;
    }
    if (!document.getElementById('nile-preview-pagination-style')) {
      const style = document.createElement('style'); style.id = 'nile-preview-pagination-style';
      style.textContent = '.nile-preview-pages{display:flex;flex-wrap:wrap;align-items:center;gap:.5rem;padding:12px 20px;font:14px/1.4 Arial,sans-serif}.nile-preview-pages__numbers{display:flex;flex-wrap:wrap;gap:.4rem}.nile-preview-pages button{font:inherit;min-width:36px;min-height:36px;padding:6px 9px;border:1px solid #b6a58e;border-radius:5px;background:#fffdfa;color:#4f3d2b;cursor:pointer}.nile-preview-pages button[aria-current=page]{background:#6d5741;color:#fff}.nile-preview-pages button:focus-visible{outline:3px solid #2462a3;outline-offset:2px}.nile-preview-pages button:disabled{opacity:.45;cursor:default}.nile-preview-pages__status{flex-basis:100%;font-size:12px}.nile-preview-page[hidden]{display:none!important}.nile-preview-page{overflow-wrap:break-word}';
      document.head.append(style);
    }
  }
  function start(scope = document) {
    scope.querySelectorAll('.nile-reading-sample__text,.product__description .nile-epub-preview blockquote').forEach(root => {
      try { enhance(root); } catch (error) { /* Original content is retained if preflight fails. */ }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(), { once: true }); else start();
  document.addEventListener('shopify:section:load', event => start(event.target));
})();
